export default ({ value, decimalToRound = 2 }: { value: number; decimalToRound?: number }): string =>
  value.toLocaleString(undefined, {
    style: 'percent',
    minimumFractionDigits: decimalToRound,
    maximumFractionDigits: decimalToRound,
  });
